import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useAppDispatch } from 'Douleutaras/redux/hooks';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { WebChatProvider } from 'Douleutaras/providers/WebChatProvider';
import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';
import ErrorBoundary from 'Douleutaras/layout/service-pages/ErrorBoundary';
import { getFeatureFlags } from 'Douleutaras/redux/data/settings/siteFeatureFlagsSlice';

import './app.scss';

export const App = () => {
  const { t } = useTranslation();
  const { countryCode } = useLocalization();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getFeatureFlags());
  }, []);

  return (
    <>
      <Helmet
        titleTemplate={COUNTRY_CONFIG.SITE_META_TITLE_TEMPLATE[countryCode]}
      >
        <title>
          {t('Dashboard')}
        </title>
        <link rel="shortcut icon" sizes="32x32"
              href={`${process.env.ASSETS_CDN_PATH}/douleutaras/img/vendor/v1/meta/${COUNTRY_CONFIG.FAV_ICON[countryCode]}.ico`} type="image/x-icon" />
      </Helmet>
      <ErrorBoundary showLayout>
        <Outlet />
      </ErrorBoundary>
      <WebChatProvider />
    </>
  );
};

export default App;
